
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile",
      function () {
        return require("private-next-pages/profile/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile"])
      });
    }
  